import { Jumbotron } from "react-bootstrap";
import { NewButton } from "../../../elements/ActionButtons/NewButton.jsx";

import AddBankButton from "../../../elements/ActionButtons/AddBankButton";
import ConnectBankButton from "../../../elements/ActionButtons/ConnectBankButton";

import React from "react";
import { injectIntl } from "react-intl";

const EmptyPaymentListJumbo = props => {
  return (
    <Jumbotron>
      <h1>{props.intl.formatMessage({ id: "noPayment_jumbo_title" })}</h1>
      <p>
        {props.intl.formatMessage({ id: "ids_createPaymentByClickingNew" })}
      </p>
      <p>
        <ConnectBankButton 
          className="btn-fill"
          onClick={
            props.BiAccessToken === undefined || props.BiAccessToken === "" || props.bankAccountCounts === 0
              ? () => props.clickNew()
              : () => props.clickEdit()
          }
          ids={
            props.BiAccessToken === undefined || props.BiAccessToken === "" || props.ankAccountCounts === 0
              ? "ids_connectMyBank"
              : "ids_connectMyBank"
          }
        />

        <AddBankButton className="btn-fill"
          onClick={() => props.history.push("/payments/bank_accounts/new")}
        />
      </p>
    </Jumbotron>
  );
};

export default injectIntl(EmptyPaymentListJumbo);
